import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

interface PagerProps {
  /** The rows on this page, 1-based ("26–50"), and how many there are in all. */
  from: number;
  to: number;
  total: number;
  /** Between the buttons, such as "Pagina 2 van 5". */
  position?: string;
  previousLabel: string;
  nextLabel: string;
  canPrevious: boolean;
  canNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

/** Under a paged table: which rows show, and the buttons to the page before and after. */
export function Pager({
  from,
  to,
  total,
  position,
  previousLabel,
  nextLabel,
  canPrevious,
  canNext,
  onPrevious,
  onNext,
}: PagerProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
      <span className="text-muted tabular-nums">{t("common.pageRange", { from, to, total })}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={!canPrevious} onClick={onPrevious}>
          <ChevronLeft className="h-4 w-4" aria-hidden="true" />
          {previousLabel}
        </Button>
        {position && <span className="text-muted tabular-nums">{position}</span>}
        <Button variant="outline" size="sm" disabled={!canNext} onClick={onNext}>
          {nextLabel}
          <ChevronRight className="h-4 w-4" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
